import React from 'react';
import { Grid, TextField } from '@mui/material';
import { ICampoIndiceProps } from './ICampoIndiceProps';

export const CampoIntervaloNumerico: React.FC<ICampoIndiceProps> = ({ indice, valor, disabled, onChange, onEnterKeyDown }) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onEnterKeyDown?.();
            e.preventDefault();
        }
    };

    return (
        <>
            <Grid item xs={6} sm={6} md={2} key={'menor-' + indice.idIndice}>
                <TextField
                    key={'RangeNumeroMenor-' + indice.idIndice}
                    type="number"
                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 0 }}
                    fullWidth
                    label={indice.nomeIndice}
                    placeholder={`Digite o ${indice.nomeIndice}`}
                    disabled={disabled}
                    value={valor?.split(' - ')[0] ?? ''}
                    onChange={(event) => {
                        let novoValor: string;
                        if (valor === undefined) {
                            novoValor = event.target.value + ' - ';
                        } else if (valor.charAt(0) === '-') {
                            novoValor = event.target.value + ' ' + valor;
                        } else {
                            novoValor = event.target.value + ' - ' + valor?.split(' - ')[1];
                        }
                        onChange(novoValor);
                    }}
                />
            </Grid>
            <Grid item xs={6} sm={6} md={2} key={'maior-' + indice.idIndice}>
                <TextField
                    key={'RangeNumeroMaior-' + indice.idIndice}
                    type="number"
                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 0 }}
                    fullWidth
                    label={indice.nomeIndice}
                    placeholder={`Digite o ${indice.nomeIndice}`}
                    disabled={disabled}
                    value={valor?.split(' - ')[1] ?? ''}
                    onKeyDown={handleKeyDown}
                    onChange={(event) => {
                        let novoValor: string;
                        if (valor === undefined || valor.charAt(0) === '-') {
                            novoValor = '- ' + event.target.value;
                        } else {
                            novoValor = valor?.split(' - ')[0] + ' - ' + event.target.value;
                        }
                        onChange(novoValor);
                    }}
                />
            </Grid>
        </>
    );
};
